/**
 * Filters out empty values from search criteria
 * @param {Object} criteria - The search criteria object
 * @returns {Object} - Filtered criteria object with only non-empty values
 */
export const filterEmptyFields = (criteria) => {
    return Object.entries(criteria).reduce((acc, [key, value]) => {
        // Include field only if:
        // - It's not null/undefined
        // - It's not an empty string
        // - If it's an array, include it always
        // - For numbers, include 0 as valid value
        if (
            value !== null &&
            value !== "" &&
            value !== undefined &&
            (Array.isArray(value) || value === 0 || value)
        ) {
            acc[key] = value
        }
        return acc
    }, {})
} 